import { request } from '@/data/request';

export const fetchToken = async (token: string): Promise<any> => {
  return request({
    method: 'post',
    url: `/auth/verify-reset-establishment-user-token`,
    data: { token },
  });
};

export const updatePassword = async (
  token: string,
  password: string,
  userId?: number,
): Promise<any> => {
  return request<any>({
    method: 'post',
    url: `/auth/reset-establishment-user-password`,
    data: { token, password, user_id: userId },
  });
};

export const forgotPassword = async (email: string): Promise<any> => {
  return request<any>({
    method: 'post',
    url: `/auth/forgot-password-invite`,
    data: { email },
  });
};
